// src/App.js
import React from 'react';
import { Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import ScrollToTop from "./components/ScrollToTop"
import SupplyChainPage from './pages/supplychain';
import Predictive from './pages/Predictive';
import Security from './pages/security';
import Smart from './pages/smart';
import Enhanced from './pages/enhanced';
import Manufacturing from './pages/manufacturing';
import Warehouse from './pages/warehouse';
import Retail from './pages/retail';
import Construction from './pages/construction';
import Contact from './pages/contact';
import Terms from './pages/terms';
import Privacy from './pages/privacy';
import Accessibility from './pages/accessibility';
import Logistics from './pages/logistics';
import  Pricing from './pages/pricing';
import Demo from './pages/Demo';
import Googleformdemo from './components/Googleformdemo'
function App() {
  return (
    <>
    <ScrollToTop/>
    <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/supplychain" element={<SupplyChainPage />} />
        <Route path="/Predictive" element={<Predictive />} />
        <Route path="/Security" element={<Security />} />
        <Route path="/Smart" element={<Smart />} />
        <Route path="/Enhanced" element={<Enhanced />} />
        <Route path="/Manufacturing" element={<Manufacturing />} />
        <Route path="/Warehouse" element={<Warehouse />} />
        <Route path="/Retail" element={<Retail />} />
        <Route path="/construction" element={<Construction />} />
        <Route path="/logistics" element={<Logistics />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/demo" element={<Googleformdemo/>} />
        <Route path="/Pricing" element={<Pricing/>} />
        <Route path="/demo1" element={<Demo/>} />
        
        <Route path="/Terms" element={<Terms/>} />
        <Route path="/Privacy" element={<Privacy/>} />
        <Route path="/Accessibility" element={<Accessibility/>} />
        
        
        
        {/* Add other routes here */}
    </Routes>
    </>
    


  );
}

export default App;

